import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import formatAssociationDefinitions from 'automation-ui-associations/utils/formatAssociationDefinitions';
export const GET_ASSOCIATION_DEFINITIONS = registerQuery({
  fieldName: 'associations_associationDefinitions',
  args: ['objectTypeIds'],
  fetcher({
    objectTypeIds
  }) {
    return http.get('associations/v1/definitions/from-object-types', {
      query: {
        objectTypeId: objectTypeIds,
        // For forwards compatibility with Flexible Associations, we use
        // definitions that are only appear in the query for portals ungated
        // to FA. Enabling this flag includes those defintions for all portals
        includeFATypes: true
      }
    }).then(formatAssociationDefinitions);
  }
});